/**
 * Control Visibility of mobile alert popup when product add to cart
 * @param {boolean} status - whether show(true) or Hide(false)
 */
function alertPopupVisiblity(status) {
  let alertContEl = document.querySelector("#pdp_alert_cont");
  if (status) {
    alertContEl.classList.add("active");
  } else {
    alertContEl.classList.remove("active");
  }
}

let alertCloseEle = document.querySelector(".pdp-alert-close");
let alertOverlayEle = document.querySelector(".pdp-alert-overlay");

// close popup on close icon and overlay
[alertCloseEle, alertOverlayEle].forEach((ele) =>
  ele.addEventListener("click", () => alertPopupVisiblity(false))
);
